import { useTheme } from "@emotion/react";
import {
  AccessTimeOutlined,
  AlarmOutlined,
  ApartmentOutlined,
  CalendarTodayOutlined,
  ContentCopy,
  LocalOfferOutlined,
  PersonOutlineOutlined,
  SensorDoorOutlined,
  SubtitlesOutlined,
  SupportAgentOutlined,
  TimelineOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { ChipPrioridade } from "../../../utils/chipsErp/chipPrioridade";
import { ChipSla } from "../../../utils/chipsErp/chipSla";
import { StatusIconCard } from "../../../utils/chipsErp/chipStatusCard";

import useStyles from "./styles";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import TicketModalContentIxc from "../detailsTicketIxcComponent";
import dayjs from "dayjs";
import { getErpPrincipal } from "../../../services/erpSistema";

// `erpTela`: ERP escolhido na tela; sem ele, a variável do front.
const configParamsErp = (params, erpTela) => {
  const erp = erpTela || getErpPrincipal();

  switch (params) {
    case "filial":
      return erp === "IXC" ? "Filial" : "Local";
      break;
    case "assunto":
      return erp === "IXC" ? "Assunto" : "Tipo de solicitação";
      break;
    case "setor":
      return erp === "IXC" ? "Setor" : "Equipe";
      break;
  }
};

export default function TicketComponentIxc(params) {
  const {
    protocolo = "",
    filial = "",
    descricao = "",
    cliente = "",
    dataCadastro = "",
    usuarioAbertura = "",
    status = 1,
    ticketId = "",
    id_ticket = "",
    getTicketDetails = () => {},
    isEdit = false,
    setSnackbar = () => {},
    selectedCliente = "",
    servicoId = "",
    labelErp = "",
    variantPaper = "elevation",
    historicoFluxoAtendimento = [],
    allEtapasFluxoAtendimentos = [],
    refreshAtendimentos = () => {},
    setor = "",
    prioridade = "",
    assunto = "",
    sla = "",
    isAtendimento = false,
    typeTitleModal = "Atendimento",
    isOs = false,
    hiddenTimeLine = false,
    // ERP escolhido na tela (tipo e id); sem eles, a variável do front.
    erp: erpProp,
    erpId,
  } = params;

  const erp = erpProp || getErpPrincipal();
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const [isEditOs, setIsEditOs] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);

  const [loading, setLoading] = useState(true);
  const [ticketDetails, setTicketDetails] = useState({});

  const [value, setValue] = useState(0);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [isEditTicket, setIsEditTicket] = useState(false);
  const [editedTicket, setEditedTicket] = useState(false);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const colors = Object.keys(theme.palette.colors)?.filter(
    (color) => color !== "white" && color !== "black",
  );

  function adicionarCores(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }
  const getTicketDetailsAtendimento = async (ticketId) => {
    try {
      const response = await api.post("/interno/find/tickets/id", {
        ticketId: ticketId,
        erpId,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível localizar detalhes do ticket",
        severity: "error",
      });
    } finally {
    }
  };

  const statusChamado = {
    "Aguardando Análise": 1,
    Resolvido: 2,
    Pendente: 3,
    Cancelado: 4,
    Aberto: 5,
    Encaminhado: 6,
    Agendado: 7,
    "Em Análise": 8,
    Assumido: 9,
    "Em execução": 10,
    Finalizado: 11,
    Deslocamento: 12,
    Reagendar: 13,
    NA: 14,
    Solucionado: 15,
    Novo: 16,
    "Em progresso": 17,
    Fechamento: 18,
    Encerramento: 19,
    Abertura: 20,
    Andamento: 21,
    "Ag. Classificação": 22,
  };

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  function htmlForText(html) {
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    function extrairTexto(node) {
      let texto = "";

      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          texto += child.textContent;
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const tag = child.tagName;

          switch (tag) {
            case "BR":
              texto += "\n";
              break;
            case "P":
            case "DIV":
              texto += extrairTexto(child) + "\n";
              break;
            case "LI":
              texto += "- " + extrairTexto(child) + "\n";
              break;
            case "UL":
            case "OL":
              texto += extrairTexto(child) + "\n";
              break;
            default:
              texto += extrairTexto(child);
          }
        }
      });

      return texto;
    }

    // Extrai texto e normaliza múltiplas quebras de linha
    const resultado = extrairTexto(tempDiv);
    return resultado.replace(/\n{3,}/g, "\n\n").trim();
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setIsEditOs(false);
    setIsEditTicket(false);
  };

  const handleOpen = async () => {
    setOpen(true);
    setLoading(true);
    const response = await getTicketDetails(ticketId);

    setTicketDetails(response || {});
    setItensPublic((prev) => {
      const mensagens = [];
      const anexos = [];
      const anexosCliente = [];
      const rfo = [];
      for (const item of response?.itensTicketPublic || []) {
        if (item?.itemType === "mensagem") {
          mensagens.push(item?.itemId);
        } else if (item?.itemType === "anexo") {
          anexos?.push(item?.itemId);
        } else if (item?.itemType === "anexoCliente") {
          anexosCliente?.push(item?.itemId);
        } else if (item?.itemType === "rfo") {
          rfo?.push(item?.itemId);
        }
      }

      return {
        ...prev,
        mensagens,
        anexos,
        anexosCliente,
        rfo,
      };
    });

    setLoading(false);
  };

  const handleOpenAtendimento = async (ticketId) => {
    const response = await getTicketDetailsAtendimento(ticketId);

    setItensPublic((prev) => {
      const mensagens = [];
      const anexos = [];
      const anexosCliente = [];
      const rfo = [];
      for (const item of response?.itensTicketPublic || []) {
        if (item?.itemType === "mensagem") {
          mensagens.push(item?.itemId);
        } else if (item?.itemType === "anexo") {
          anexos?.push(item?.itemId);
        } else if (item?.itemType === "anexoCliente") {
          anexosCliente?.push(item?.itemId);
        } else if (item?.itemType === "rfo") {
          rfo?.push(item?.itemId);
        }
      }

      return {
        ...prev,
        mensagens,
        anexos,
        anexosCliente,
        rfo,
      };
    });

    setLoading(false);
  };
  const handleClose = () => {
    setOpen(false);
    setValue(0);
    setIsEditOs(false);
    setIsNewOs(false);
    setIsEditTicket(false);
    setConfirmacaoSaidaPagina(false);

    if (editedTicket) {
      refreshAtendimentos();
      setEditedTicket(false);
    }
  };

  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };
  const formatTotalTime = (historyArray) => {
    // 1. Soma todos os minutos do array
    const totalMinutes =
      historyArray?.reduce((acc, item) => acc + (item.timeEtapa || 0), 0) || 0;

    if (totalMinutes === 0) return "0 min";

    // Constantes de conversão
    const MIN_IN_HOUR = 60;
    const MIN_IN_DAY = 1440; // 60 * 24
    const MIN_IN_YEAR = 525600; // 1440 * 365

    let remaining = totalMinutes;

    const years = Math.floor(remaining / MIN_IN_YEAR);
    remaining %= MIN_IN_YEAR;

    const days = Math.floor(remaining / MIN_IN_DAY);
    remaining %= MIN_IN_DAY;

    const hours = Math.floor(remaining / MIN_IN_HOUR);
    const minutes = remaining % MIN_IN_HOUR;

    // 2. Monta a string de forma amigável
    const parts = [];
    if (years > 0) parts.push(`${years} ${years === 1 ? "ano" : "anos"}`);
    if (days > 0) parts.push(`${days} ${days === 1 ? "dia" : "dias"}`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || parts.length === 0) parts.push(`${minutes}min`);

    return parts.join(" ");
  };
  function converterMinutos(totalMinutos) {
    if (!totalMinutos)
      return {
        text: "Menos de 1 minuto",
        hora: 0,
        minuto: 0,
      };
    const horas = Math.floor(totalMinutos / 60);
    const minutos = totalMinutos % 60;

    return { text: `${horas}h ${minutos}m`, hora: horas, minuto: minutos };
  }
  function adicionarCores(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }
  const fluxoAtendimentoColor = adicionarCores(
    ticketDetails?.allEtapasFluxoAtendimentos,
  );
  const fluxoAtendimentoColorIxc = {
    Novo: theme.palette.colors.blue.dark,
    Pendente: theme.palette.cardTrafficData.paperColor.outputData,
    "Em progresso": theme.palette.cardTrafficData.paperColor.inputData,
  };
  const fluxoAtendimentoColorOsIxc = {
    Aberto: theme.palette.cardTrafficData.paperColor.outputData,
    Encaminhado: theme.palette.cardTrafficData.paperColor.speeData,
    Agendado: theme.palette.cardTrafficData.paperColor.inputData,
    Reagendar: theme.palette.colors.pink.dark,
    "Em Análise": theme.palette.colors.orange.darker,
    Assumido: theme.palette.colors.blue.dark,
    "Em execução": theme.palette.colors.yellow.darker,
    "Deslocamento:": theme.palette.colors.purple.dark,
  };

  const selectColorsTypeErp = (descricaoEtapa) => {
    switch (erp) {
      case "HUBSOFT":
        return theme.palette.colors[fluxoAtendimentoColor[descricaoEtapa]]
          .medium;

      case "IXC":
        return isOs
          ? fluxoAtendimentoColorOsIxc[descricaoEtapa]
          : fluxoAtendimentoColorIxc[descricaoEtapa];
      default:
        return null;
    }
  };

  const customTooltip = (
    <Box sx={styles.containerCustomTooltip}>
      <Box sx={styles.boxCustomTooltip}>
        <Typography sx={styles.titleCustomTooltip}>
          Histórico do ticket
        </Typography>
        <Box sx={styles.boxChip}>
          <Box variant="outlined" sx={styles.chipTime}>
            <AccessTimeOutlined sx={{ fontSize: "16px " }} />
            <Typography
              variant="caption"
              sx={{ fontWeight: 600, color: theme.palette.white.main }}
            >
              Tempo total: {formatTotalTime(historicoFluxoAtendimento)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Paper
        variant="outlined"
        sx={{
          p: 1,
          backgroundColor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.colors.black.dark, 0.4)
              : theme.palette.colors.black.lighter,
        }}
      >
        <Box sx={styles.containerTimeline}>
          {historicoFluxoAtendimento?.map((item, index) => (
            <>
              <Paper variant="outlined" sx={styles.paperTimeline} key={index}>
                <Box
                  sx={{
                    ...styles.boxTimeline,
                    backgroundColor: selectColorsTypeErp(item?.descricaoEtapa),
                  }}
                />
                <Box sx={{ marginLeft: "10px" }}>
                  <Typography sx={styles.titleEtapa}>
                    {item?.descricaoEtapa}
                  </Typography>

                  <Typography sx={{ fontSize: "12px" }}>
                    <Box component="span" sx={{ fontWeight: "bold" }}>
                      De:
                    </Box>{" "}
                    {dayjs(item?.initialDate).format("DD/MM/YY HH:mm")}
                  </Typography>

                  <Typography sx={{ fontSize: "12px" }}>
                    <Box component="span" sx={{ fontWeight: "bold" }}>
                      Até:
                    </Box>{" "}
                    {index === historicoFluxoAtendimento?.length - 1 &&
                    status !== "Resolvido"
                      ? "Atualmente"
                      : dayjs(item?.finalDate).format("DD/MM/YY HH:mm")}
                  </Typography>

                  <Typography sx={{ fontSize: "12px" }}>
                    <Box component="span" sx={{ fontWeight: "bold" }}>
                      Tempo na etapa:
                    </Box>{" "}
                    {converterMinutos(item?.timeEtapa)?.text}
                  </Typography>
                </Box>
              </Paper>
            </>
          ))}
        </Box>
      </Paper>
    </Box>
  );
  return (
    <Paper
      elevation={theme.palette.mode == "dark" ? 0 : 3}
      variant={variantPaper}
      sx={styles.paperContainer}
    >
      <Box sx={styles.boxHeaderStatus}>
        {StatusIconCard([statusChamado[status]], 2)}

        {ChipPrioridade(prioridade)}
      </Box>
      {erp === "IXC" &&
        historicoFluxoAtendimento?.length > 0 &&
        !hiddenTimeLine && (
          <Tooltip
            placement="right"
            arrow
            title={
              !open && historicoFluxoAtendimento?.length > 0
                ? customTooltip
                : ""
            }
            // Mantém aberto enquanto o mouse estiver sobre o conteúdo do Tooltip
            componentsProps={{
              tooltip: {
                onMouseEnter: () => setIsHovered(true),
                onMouseLeave: () => setIsHovered(false),
              },
            }}
          >
            <Box
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              sx={{
                ...styles.boxHistorico,
                width: isHovered ? 100 : 30, // Controlado pelo estado

                // O texto agora reage ao estado isHovered
                "& .texto-historico": {
                  opacity: isHovered ? 1 : 0,
                  transition: "opacity 0.3s ease-in-out",
                  marginLeft: "10px",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TimelineOutlined sx={{ fontSize: "15px", minWidth: "15px" }} />
              <Typography
                className="texto-historico"
                sx={{ fontSize: "12px", fontWeight: 500 }}
              >
                Histórico
              </Typography>
            </Box>
          </Tooltip>
        )}
      <Box sx={styles.containerHeader}>
        <Box sx={styles.boxProtocolo}>
          <Typography sx={styles.textInfoCard}> Protocolo:</Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {protocolo}
          </Typography>

          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(protocolo);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = protocolo;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={styles.boxProtocolo}>
          <Typography sx={styles.textInfoCard}> {labelErp} ID:</Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {servicoId}
          </Typography>

          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(servicoId);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = servicoId;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={styles.containerDescription}>
        <Typography sx={styles.description}>
          {(erp === "HUBSOFT" && descricao) ||
            (erp === "VOALLE" && htmlForText(descricao)) ||
            (erp === "IXC" && descricao)}
        </Typography>
      </Box>
      <Box sx={styles.boxInfos}>
        <Box
          sx={{
            ...styles.containerInfo,
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => {
            if (selectedCliente?.id) {
              const clienteFilterData = JSON.parse(
                localStorage.getItem("filterData"),
              );

              let clientStorage = clienteFilterData;
              if (clienteFilterData?.clienteId !== selectedCliente?.id) {
                clientStorage = {
                  interfaceId: "",
                  clienteId: selectedCliente?.id,
                  hostId: "",
                  selectTime: 5,
                  initialDate: "",
                  finalDate: "",
                };
              }
              localStorage.setItem("filterData", JSON.stringify(clientStorage));
              navigate(`/interno/home/perfil/servicos/${selectedCliente?.id}`);
            } else {
              setSnackbar({
                children: "Cliente não cadastrado no sistema",
                severity: "warning",
              });
            }
          }}
        >
          <PersonOutlineOutlined
            sx={{
              ...styles.icon,
            }}
          />{" "}
          <Typography sx={styles.cardDescricao}>{cliente}</Typography>
        </Box>

        <Box sx={styles.containerInfoRow}>
          <Box sx={styles.containerDataAberturaRow}>
            <CalendarTodayOutlined
              sx={{
                ...styles.icon,

                fontSize: "18px",
              }}
            />{" "}
            <Tooltip title={"Data de abertura"}>
              <Typography sx={styles.cardDescricao}>{dataCadastro}</Typography>
            </Tooltip>
          </Box>
          <Box sx={styles.containerDataAberturaRow}>
            <Tooltip
              title={"SLA"}
              style={{ display: "flex", alignItems: "center", gap: 5 }}
            >
              <AlarmOutlined
                sx={{
                  ...styles.icon,

                  fontSize: "18px",
                }}
              />
              {ChipSla(sla)}
            </Tooltip>
          </Box>
        </Box>
        <Box sx={styles.containerInfoRow}>
          <Box
            sx={{
              ...styles.containerDataAberturaRow,
              width: id_ticket ? "50%" : "100%",
            }}
          >
            <SensorDoorOutlined
              sx={{
                ...styles.icon,
              }}
            />{" "}
            <Tooltip title={configParamsErp("setor", erp)}>
              <Typography
                sx={{
                  ...styles.cardDescricao,
                }}
              >
                {setor}
              </Typography>
            </Tooltip>
          </Box>
          {Number(id_ticket) > 0 && (
            <Box
              sx={{
                ...styles.containerDataAberturaRow,
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => {
                handleOpenAtendimento(id_ticket);
              }}
            >
              <Tooltip
                title={"ID atendimento"}
                style={{ display: "flex", alignItems: "center", gap: 5 }}
              >
                <LocalOfferOutlined
                  sx={{
                    ...styles.icon,
                    fontSize: "18px",
                  }}
                />
                <Typography
                  sx={{
                    ...styles.cardDescricao,
                  }}
                >
                  {id_ticket || ""}
                </Typography>
              </Tooltip>
            </Box>
          )}
        </Box>

        <Box sx={styles.containerInfo}>
          <SubtitlesOutlined
            sx={{
              ...styles.icon,
            }}
          />{" "}
          <Tooltip title={configParamsErp("assunto", erp)}>
            <Typography
              sx={{
                ...styles.cardDescricao,
              }}
            >
              {assunto}
            </Typography>
          </Tooltip>
        </Box>
        <Box sx={styles.containerInfo}>
          <ApartmentOutlined
            sx={{
              ...styles.icon,
            }}
          />{" "}
          <Tooltip title={configParamsErp("filial", erp)}>
            <Typography
              sx={{
                ...styles.cardDescricao,
              }}
            >
              {filial}
            </Typography>
          </Tooltip>
        </Box>

        <Box sx={styles.containerInfo}>
          <SupportAgentOutlined
            sx={{
              ...styles.icon,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          />{" "}
          <Typography
            sx={{
              ...styles.cardDescricao,
              fontWeight: "bold",
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {usuarioAbertura}
          </Typography>
        </Box>
        <Box sx={styles.containerButton}>
          <Button
            onClick={handleOpen}
            sx={styles.buttonDetails}
            startIcon={<VisibilityOutlined />}
            variant="outlined"
            size="small"
          >
            Ver detalhes
          </Button>
        </Box>
      </Box>
      <TicketModalContentIxc
        open={open}
        loading={loading}
        handleClose={handleClose}
        erp={erp}
        erpId={erpId}
        ticketDetails={ticketDetails}
        status={statusChamado[status]}
        labelTabsErp={labelTabsErp}
        value={value}
        handleChange={handleChange}
        isEdit={isEdit}
        setTicketDetails={setTicketDetails}
        itensPublic={itensPublic}
        setItensPublic={setItensPublic}
        htmlForText={htmlForText}
        setSnackbar={setSnackbar}
        isAtendimento={isAtendimento}
        typeTitleModal={typeTitleModal}
        setIsEditTicket={setIsEditTicket}
        setEditedTicket={setEditedTicket}
        isEditTicket={isEditTicket}
        isOs={isOs}
        isEditOs={isEditOs}
        setIsEditOs={setIsEditOs}
        setIsNewOs={setIsNewOs}
        isNewOs={isNewOs}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoSaidaPagina}
        confirmLoad={false}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        execute={handleClose}
        cancel={handleCancelNavigation}
        severity={"warning"}
        title={"Atenção"}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
        headerText={"Você está prestes a sair do modo de edição."}
        confirmText={"Continuar"}
      />
    </Paper>
  );
}
